import {
  getApiV1Me,
  postApiV1Signin,
  postApiV1Signout,
  postApiV1MePassword,
  getApiV1MeConnections,
  getApiV1MeSessions,
  deleteApiV1MeSessions,
  postApiV1ForgotPassword,
  postApiV1ResetPassword,
  putApiV1Me,
  putApiV1MeEmail,
  postApiV1RequestEmailChange,
  putApiV1ProcessEmailChange,
  getApiV3SsoSettings,
  postApiV1SigninRedirect,
  postApiV1OauthTwitterSignin,
  postApiV1OauthTwitterSignup,
  postApiV1OauthTwitterSigninRedirect,
  postApiV1OauthTwitterConnect,
  postApiV1OauthGithubSignin,
  postApiV1OauthGithubSignup,
  postApiV1OauthGithubSigninRedirect,
  postApiV1OauthGithubConnect,
  getApiV1OauthProfiles,
  getApiV2SsoConnections,
  deleteApiV1OauthProfilesOauthkind,
  deleteApiV1MeConnectionsJob,
  postApiV1Signup,
  getApiV1SignupEmailToken,
  postApiV1Link,
  getApiV1SsoSigninRedirect,
  getApiV1SsoSignup,
  getApiV1SsoConnectEntityid,
  postSamlCallbackEntityid,
  getApiV1ImagesConfig,
  postApiV1ImagesSign,
  getApiV1Terms,
  getApiV1TermsMe,
  postApiV1TermsAccept,
} from "@givery-technology/track-id-frontend-sdk/generated-sdk/models";

import {
  SignInInput,
  ModifyPasswordInput,
  ResetPasswordInput,
  UpdateEmailAddressInput,
  RequestEmailChangeInput,
  SSOSettingsParams,
  SignInRedirectInput,
  ProcessEmailChangeInput,
  TwitterCallbackInput,
  GithubCallbackInput,
  OAuthKind,
  RemoveJobConnectionInput,
  UpdateUserInput,
  LinkConnectionInput,
  SSOSigninRedirectParams,
  SSOSignupParams,
  SamlCallbackInput,
  CloudinarySignInput,
  AcceptTermsInput,
  TermsParams,
  TermsMeParams,
} from "@utils/types";

const BASE_V1 = "/api/v1";

export const API = {
  OAUTH_SERVICE_SIGNIN: BASE_V1 + "/oauth/signin/redirect",
  OAUTH_GITHUB_AUTH: BASE_V1 + "/oauth/github/auth",
  OAUTH_TWITTER_AUTH: BASE_V1 + "/oauth/twitter/auth",
  SSO_SERVICE_SIGNIN: BASE_V1 + "/sso/signin/redirect",
  SSO_CONNECT: BASE_V1 + "/sso/connect",
} as const;

export const getMe = async () => {
  const response = await getApiV1Me();

  return response.data;
};

export const putMe = async (body: UpdateUserInput) => {
  const response = await putApiV1Me(body);

  return response.data;
};

export const postSignup = async (body: any) => {
  const response = await postApiV1Signup(body);

  return response.data;
};

export const getSignupEmailToken = async (token: string) => {
  const response = await getApiV1SignupEmailToken(token);

  return response.data;
};

export const postSignupLink = async (body: LinkConnectionInput) => {
  const response = await postApiV1Link(body);

  return response.data;
};

export const postSignin = async (body: SignInInput) => {
  const response = await postApiV1Signin(body);

  return response.data;
};

export const postSigninRedirect = async (body: SignInRedirectInput) => {
  const response = await postApiV1SigninRedirect(body);

  return response.data;
};

export const postOauthTwitterSignin = async (body: TwitterCallbackInput) => {
  const response = await postApiV1OauthTwitterSignin(body);

  return response.data;
};

export const postOauthTwitterSignup = async (body: TwitterCallbackInput) => {
  const response = await postApiV1OauthTwitterSignup(body);

  return response.data;
};

export const postOauthTwitterSigninRedirect = async (
  body: TwitterCallbackInput,
) => {
  const response = await postApiV1OauthTwitterSigninRedirect(body);

  return response.data;
};

export const postOauthTwitterConnect = async (body: TwitterCallbackInput) => {
  const response = await postApiV1OauthTwitterConnect(body);

  return response.data;
};

export const postOauthGithubSignin = async (body: GithubCallbackInput) => {
  const response = await postApiV1OauthGithubSignin(body);

  return response.data;
};

export const postOauthGithubSignup = async (body: GithubCallbackInput) => {
  const response = await postApiV1OauthGithubSignup(body);

  return response.data;
};

export const postOauthGithubSigninRedirect = async (
  body: GithubCallbackInput,
) => {
  const response = await postApiV1OauthGithubSigninRedirect(body);

  return response.data;
};

export const postOauthGithubConnect = async (body: GithubCallbackInput) => {
  const response = await postApiV1OauthGithubConnect(body);

  return response.data;
};

export const postSignout = async () => {
  const response = await postApiV1Signout();

  return response.data;
};

export const postChangePassword = async (body: ModifyPasswordInput) => {
  const response = await postApiV1MePassword(body);

  return response.data;
};

export const getConnections = async () => {
  const response = await getApiV1MeConnections();

  return response.data;
};

export const getSessions = async () => {
  const response = await getApiV1MeSessions();

  return response.data.sessions;
};

export const deleteSession = async (deviceId: string) => {
  const response = await deleteApiV1MeSessions({ deviceId });

  return response.data;
};

export const getSSOSettings = async (params: SSOSettingsParams) => {
  const response = await getApiV3SsoSettings(params);

  return response.data;
};

export const postForgotPassword = async (email: string) => {
  const response = await postApiV1ForgotPassword({ email });

  return response.data;
};

export const postResetPassword = async (body: ResetPasswordInput) => {
  const response = await postApiV1ResetPassword(body);

  return response.data;
};

export const postChangeEmail = async (body: UpdateEmailAddressInput) => {
  const response = await putApiV1MeEmail(body);

  return response.data;
};

export const postRequestEmailChange = async (body: RequestEmailChangeInput) => {
  const response = await postApiV1RequestEmailChange(body);

  return response.data;
};

export const putProcessEmailChange = async (body: ProcessEmailChangeInput) => {
  const response = await putApiV1ProcessEmailChange(body);

  return response.data;
};

export const getOauthProfiles = async () => {
  const response = await getApiV1OauthProfiles();

  return response.data;
};

export const getSsoConnections = async () => {
  const response = await getApiV2SsoConnections();

  return response.data;
};

export const deleteOauthProfile = async (kind: OAuthKind) => {
  const response = await deleteApiV1OauthProfilesOauthkind(kind);

  return response.data;
};

export const deleteJobConnection = async (body: RemoveJobConnectionInput) => {
  const response = await deleteApiV1MeConnectionsJob(body);

  return response.data;
};

export const getSSOSigninRedirect = async (params: SSOSigninRedirectParams) => {
  const response = await getApiV1SsoSigninRedirect(params);

  return response.data;
};

export const getSSOSignup = async (params: SSOSignupParams) => {
  const response = await getApiV1SsoSignup(params);

  return response.data;
};

export const getSSOConnect = async (entityId: string) => {
  const response = await getApiV1SsoConnectEntityid(entityId);

  return response.data;
};

export const postSamlCallback = async ({
  entityId,
  body,
}: {
  entityId: string;
  body: SamlCallbackInput;
}) => {
  const response = await postSamlCallbackEntityid(entityId, body);

  return response.data;
};

export const getImagesConfig = async () => {
  const response = await getApiV1ImagesConfig();

  return response.data;
};

export const postImagesSign = async (body: CloudinarySignInput) => {
  const response = await postApiV1ImagesSign(body);

  return response.data;
};

export const getTerms = async (params: TermsParams) => {
  const response = await getApiV1Terms(params);

  return response.data;
};

export const getTermsMe = async (params: TermsMeParams) => {
  const response = await getApiV1TermsMe(params);

  return response.data;
};

export const getTermsContent = async (contentLink: string) => {
  const response = await fetch(contentLink);

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.text();
};

export const postTermsAccept = async (body: AcceptTermsInput) => {
  const response = await postApiV1TermsAccept(body);

  return response.data;
};
